var _path, _path2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgAccountBalanceWallet(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M28 9.70667V6.66667C28 5.2 26.8 4 25.3333 4H6.66667C5.18667 4 4 5.2 4 6.66667V25.3333C4 26.8 5.18667 28 6.66667 28H25.3333C26.8 28 28 26.8 28 25.3333V22.2933C28.7867 21.8267 29.3333 20.9867 29.3333 20V12C29.3333 11.0133 28.7867 10.1733 28 9.70667ZM26.6667 12V20H17.3333V12H26.6667ZM6.66667 25.3333V6.66667H25.3333V9.33333H17.3333C15.8667 9.33333 14.6667 10.5333 14.6667 12V20C14.6667 21.4667 15.8667 22.6667 17.3333 22.6667H25.3333V25.3333H6.66667Z",
    fill: "#2541B2"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M21.3333 18C22.4379 18 23.3333 17.1046 23.3333 16C23.3333 14.8954 22.4379 14 21.3333 14C20.2288 14 19.3333 14.8954 19.3333 16C19.3333 17.1046 20.2288 18 21.3333 18Z",
    fill: "#2541B2"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgAccountBalanceWallet);
export default __webpack_public_path__ + "static/media/account_balance_wallet.e480f73375083bf4c1824d803507c9fb.svg";
export { ForwardRef as ReactComponent };